import {
    LEGAL_AUTHORIZATION,
    LEGAL_AUTHORIZATION_SUCCESS,
    LEGAL_AUTHORIZATION_ERROR
} from './actionTypes';

export const postLegalAuthorization = (value: any) => ({
    type : LEGAL_AUTHORIZATION,
    value
});

export const postLegalAuthorizationSuccess = (data: any) => ({
    type: LEGAL_AUTHORIZATION_SUCCESS,
    payload: data
});

export const postLegalAuthorizationError = (error: any) => ({
    type: LEGAL_AUTHORIZATION_ERROR,
    payload: error
});